import { decodeMessageContent } from '../internal/conversation/decodeMessageContent';

export type ConversationMessage = { id?: string; role: string; is_final: boolean; content: unknown };

const currentTurnStart = (messages: ConversationMessage[]) => {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'user') {
      return i + 1;
    }
  }
  return 0;
};

export type PickFinalReplyOptions = { anyEnvelope?: boolean };

// Reply for the CURRENT grade. The conversation is reused across grades, so scan
// after the last user message and take the latest is_final `result`; the first
// would be a stale prior grade. undefined until this grade finishes.
export function pickFinalReply(
  messages: ConversationMessage[],
  { anyEnvelope = false }: PickFinalReplyOptions = {},
): string | undefined {
  const start = currentTurnStart(messages);

  let reply: string | undefined;
  for (let i = start; i < messages.length; i++) {
    const message = messages[i];
    if (message.role !== 'assistant' || !message.is_final) {
      continue;
    }
    const payload = decodeMessageContent(message.content);
    if ((anyEnvelope || payload?.type === 'result') && typeof payload?.result === 'string' && payload.result) {
      reply = payload.result; // keep scanning; the current grade's result is the latest one
    }
  }
  return reply;
}

export type FinalEnvelope = { result?: string; delegated?: boolean; delegationError?: string };

export function readFinalEnvelope(messages: ConversationMessage[]): FinalEnvelope | undefined {
  const start = currentTurnStart(messages);

  let envelope: FinalEnvelope | undefined;
  for (let i = start; i < messages.length; i++) {
    const message = messages[i];
    if (message.role !== 'assistant' || !message.is_final) {
      continue;
    }
    const payload = decodeMessageContent(message.content);
    if (payload?.type !== 'result') {
      continue;
    }
    envelope = {
      ...(typeof payload.result === 'string' && payload.result && { result: payload.result }),
      ...(typeof payload.delegated === 'boolean' && { delegated: payload.delegated }),
      ...(typeof payload.delegation_error === 'string' &&
        payload.delegation_error && { delegationError: payload.delegation_error }),
    };
  }
  return envelope;
}
